import { render } from "./CookiesColorPicker.vue?vue&type=template&id=a920c6fa&scoped=true"
import script from "./CookiesColorPicker.vue?vue&type=script&lang=js"
export * from "./CookiesColorPicker.vue?vue&type=script&lang=js"

import "./CookiesColorPicker.vue?vue&type=style&index=0&id=a920c6fa&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core-Abudari\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a920c6fa"]])

export default __exports__